import { ExternalLms } from '../../../typings/';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getUserExternalLms(): Promise<Record<string, ExternalLms>> {
    const { apiGetUserExternalLms } = apiConfig.getStaticUrls();

    return getFetch(apiGetUserExternalLms);
}
